<div class="search-results-container">
  <div class="results-header">
    <div class="d-flex align-items-center">
      <button class="back-btn" (click)="onClose()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>
      <h2 class="header-title ml-2">Results</h2>
    </div>
    <span class="matches-count">{{ matchesCount }} matches</span>
  </div>

  <div class="results-content" #resultsScrollElement infiniteScroll [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50" (scrolled)="onScroll()" [scrollWindow]="false">
    @if (results && results.length > 0) {
    <div [style.height.px]="virtualizer.getTotalSize()" style="position: relative; width: 100%;">
      @for (virtualRow of virtualizer.getVirtualItems(); track virtualRow.index) {
      <div [style.position]="'absolute'" [style.top.px]="virtualRow.start" [style.left]="0" [style.width]="'100%'"
        [style.height.px]="virtualRow.size" class="virtual-row-item">

        @if (virtualGridData()[virtualRow.index]; as itemRow) {

        @if (filters.selectedType === 'photo') {
        <div class="gallery-grid" [style.grid-template-columns]="'repeat(' + itemRow.itemsPerRow + ', 1fr)'">
          @for (chat of itemRow.items; track (chat.id || chat._id || $index)) {
          <div class="gallery-item" (click)="onChatClick(chat)">
            <img [src]="chat.meta?.compressedImgUrl || chat.url || chat.meta?.fileUrl || chat.fileUrl || chat.message"
              class="gallery-image" alt="Search result" (error)="$any($event.target).style.display='none'">
            <div class="gallery-info">
              <span class="gallery-name" [innerHTML]="(chat.displayName || chat.name) | highlightText: filters.search"></span>
              <span class="gallery-date">{{ chat.lastMessageTimeAgo || chat.date }}</span>
            </div>
          </div>
          }
        </div>
        } @else if (filters.selectedType === 'video') {
        <div class="gallery-grid" [style.grid-template-columns]="'repeat(' + itemRow.itemsPerRow + ', 1fr)'">
          @for (chat of itemRow.items; track (chat.id || chat._id || $index)) {
          <div class="gallery-item video-gallery-item" (click)="onChatClick(chat)">
            <div class="video-thumb-bg">
              @if (chat.meta?.thumbnailUrl) {
              <img [src]="chat.meta.thumbnailUrl" class="video-thumb" alt="Video thumbnail" (error)="chat.meta.thumbnailUrl = ''">
              } @else {
              <video [src]="chat.meta?.fileUrl || chat.fileUrl || chat.message" class="video-thumb" muted
                playsinline webkit-playsinline disablePictureInPicture preload="metadata" (error)="$any($event.target).style.display='none'"></video>
              }
            </div>
            <div class="video-play-overlay">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="white">
                <circle cx="12" cy="12" r="12" fill="rgba(0,0,0,0.45)" />
                <polygon points="10 8 18 12 10 16 10 8" fill="white" />
              </svg>
            </div>
            <div class="video-duration-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="white"
                style="margin-right:3px;flex-shrink:0">
                <rect x="2" y="7" width="15" height="10" rx="2" />
                <polygon points="22 8 17 12 22 16 22 8" fill="white" />
              </svg>
            </div>
            <div class="gallery-info">
              <span class="gallery-name" [innerHTML]="(chat.displayName || chat.name) | highlightText: filters.search"></span>
              <span class="gallery-date">{{ chat.lastMessageTimeAgo || chat.date }}</span>
            </div>
          </div>
          }
        </div>
        } @else if (filters.selectedType === 'doc') {
        <div class="doc-list">
          @for (chat of itemRow.items; track (chat.id || chat._id || $index)) {
          <div class="doc-item" (click)="onChatClick(chat)">
            <div class="doc-icon-wrap" [style.background]="getDocColor(chat)">
              @if (getDocLabel(chat) === 'PDF') {
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="9" y1="13" x2="15" y2="13"></line>
                <line x1="9" y1="17" x2="15" y2="17"></line>
              </svg>
              } @else if (getDocLabel(chat) === 'DOC') {
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="9" y1="13" x2="15" y2="13"></line>
                <line x1="9" y1="17" x2="12" y2="17"></line>
              </svg>
              } @else if (getDocLabel(chat) === 'XLS' || getDocLabel(chat) === 'CSV') {
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2"></rect>
                <line x1="3" y1="9" x2="21" y2="9"></line>
                <line x1="3" y1="15" x2="21" y2="15"></line>
                <line x1="9" y1="9" x2="9" y2="21"></line>
                <line x1="15" y1="9" x2="15" y2="21"></line>
              </svg>
              } @else if (getDocLabel(chat) === 'PPT') {
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
              } @else {
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
              }
              <span class="doc-type-badge">{{ getDocLabel(chat) }}</span>
            </div>
            <div class="doc-details">
              <span class="doc-filename" [innerHTML]="getCleanFileName(chat) | highlightText: filters.search"></span>
              <span class="doc-meta">{{ getDocLabel(chat) }} &bull; <span [innerHTML]="(chat.displayName || chat.name) | highlightText: filters.search"></span></span>
            </div>
            <span class="doc-time">{{ chat.lastMessageTimeAgo || chat.date }}</span>
          </div>
          }
        </div>
        } @else {
        <div class="results-list">
          @for (chat of itemRow.items; track (chat.id || chat._id || $index)) {
          <div class="result-item" (click)="onChatClick(chat)">
            <div class="result-avatar">
              @if (chat.profileImg || chat.profileImage) {
              <img [src]="chat.profileImg || chat.profileImage" class="avatar-img"
                (error)="chat.profileImg = ''; chat.profileImage = ''">
              } @else {
              <div class="avatar-placeholder" [style.background-color]="'#4d88ff'">
                {{ (chat.displayName || chat.name || 'U').substring(0, 1).toUpperCase() }}
              </div>
              }
            </div>
            <div class="result-info">
              <div class="result-top">
                <span class="result-name" [innerHTML]="(chat.displayName || chat.name) | highlightText: filters.search"></span>
                <span class="result-date">{{ chat.lastMessageTimeAgo || chat.date }}</span>
              </div>
              <div class="result-message">
                @if (isLink(chat)) {
                <div class="link-row-info">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="link-inline-icon">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                  </svg>
                  @if (chat.meta?.title || chat.meta?.description) {
                  <div class="link-row-text">
                    @if (chat.meta?.title) {
                    <span class="link-row-title" [innerHTML]="chat.meta.title | highlightText: filters.search"></span>
                    }
                    @if (chat.meta?.description) {
                    <span class="link-row-desc" [innerHTML]="chat.meta.description | highlightText: filters.search"></span>
                    }
                  </div>
                  } @else {
                  <span class="link-row-url-only" [innerHTML]="chat.message | highlightText: filters.search"></span>
                  }
                </div>
                } @else {
                <span [innerHTML]="(getCleanFileName(chat) || chat.lastMessage?.message || chat.message) | highlightText: filters.search"></span>
                }
              </div>
            </div>
          </div>
          }
        </div>
        }
        }
      </div>
      }
    </div>
    @if (isLoading) {
    <div class="results-pagination-loader">
      <span class="pagination-spinner"></span>
      <span>Loading more...</span>
    </div>
    }
    } @else {
    <div class="empty-results">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="empty-icon">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <h3>No matches found</h3>
      <p>Try adjusting your filters to find what you're looking for.</p>
    </div>
    }
  </div>


</div>